import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { publicRoutes, ROUTES } from '@/config/routes';
import { ClientStorage } from '@/utils/clientStorage';

// const checkAuthentication = () => {
//   const location = useLocation();
//   const path = location.pathname;

//   const currentUser = ClientStorage.cookies.getItem('ques-usertoken');
//   const isProtectedRoute = protectedRoutes.includes(path);

//   if (isProtectedRoute && !currentUser) {
//     return false;
//   }

//   return true;
// };

export const PrivateRoutes = () => {
  const location = useLocation();
  const path = location.pathname;
  const isPublicRoute = publicRoutes.includes(path);
  const isAuthenticated = Boolean(ClientStorage.cookies.getItem('ques-usertoken'));

  if (!isPublicRoute && !isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
};
